export default function Content2Icon() {
  return (
    <svg
      width="115"
      height="102"
      viewBox="0 0 115 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.7228 65.3112H36.1918C34.8047 65.3112 33.6818 64.1883 33.6818 62.8012V18.1825C33.6818 16.7954 34.8047 15.6725 36.1918 15.6725H68.7228C70.1099 15.6725 71.2328 16.7954 71.2328 18.1825V62.8012C71.2328 64.1883 70.1099 65.3112 68.7228 65.3112Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M56.6849 53.273H48.2302C47.2889 53.273 46.5293 52.5134 46.5293 51.5721C46.5293 50.6309 47.2889 49.8713 48.2302 49.8713H56.6849C57.6262 49.8713 58.3858 50.6309 58.3858 51.5721C58.3858 52.5134 57.6262 53.273 56.6849 53.273Z"
        fill="#D6DCE8"
      />
      <path
        d="M60.5651 56.9555H44.3326C43.8372 56.9555 43.4409 56.5592 43.4409 56.0638C43.4409 55.5684 43.8372 55.1721 44.3326 55.1721H60.5651C61.0605 55.1721 61.4569 55.5684 61.4569 56.0638C61.4569 56.5427 61.0605 56.9555 60.5651 56.9555Z"
        fill="#D6DCE8"
      />
      <path
        d="M63.5539 33.3745C63.5539 36.7102 62.0842 39.6991 59.7558 41.7302C57.8073 43.4311 55.2477 44.4549 52.457 44.4549C49.6663 44.4549 47.1067 43.4311 45.1581 41.7137C42.8298 39.6826 41.3601 36.6937 41.3601 33.358C41.3601 27.2316 46.3306 22.2611 52.457 22.2611C58.5834 22.2611 63.5539 27.2481 63.5539 33.3745Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M59.7564 41.7302C57.8078 43.4311 55.2483 44.4549 52.4575 44.4549C49.6668 44.4549 47.1073 43.4311 45.1587 41.7137C45.9678 41.4 47.0247 40.9871 48.4448 40.4092C48.7751 40.2771 49.0228 40.0294 49.1714 39.7156C49.254 39.534 49.287 39.3523 49.287 39.1542V36.4955C49.2375 36.446 49.2044 36.38 49.1714 36.3304C48.9402 35.9836 48.7916 35.5873 48.7421 35.1745L48.5109 35.0589C47.8338 35.224 47.8834 34.4974 47.7017 33.0938C47.6357 32.5159 47.7182 32.4003 47.9825 32.3012L48.1971 32.0039C46.8761 29.0316 47.5366 27.1656 48.8411 26.505C48.4118 25.5638 48.3788 25.217 48.3788 25.217C48.3788 25.217 51.153 25.6794 52.0942 25.4977C53.2997 25.25 55.1657 25.5473 55.8593 27.1491C57.0152 27.5949 57.461 28.338 57.5601 29.1141C57.6592 29.8407 57.4445 30.6333 57.2299 31.2443C57.2133 31.2939 57.1968 31.3269 57.1803 31.3599C57.1803 31.3764 57.1638 31.393 57.1638 31.4095C57.1308 31.492 57.1143 31.5581 57.0812 31.6241C57.0647 31.6572 57.0647 31.6902 57.0482 31.7232C57.0317 31.7893 56.9987 31.8553 56.9822 31.9049C56.9822 31.9214 56.9822 31.9214 56.9656 31.9379C56.9491 31.9874 56.9326 32.037 56.9161 32.0865C56.8996 32.1526 56.8831 32.2021 56.8666 32.2516C56.8831 32.2682 56.8831 32.3012 56.8996 32.3177C57.0812 32.4003 57.1473 32.5654 57.0812 33.0773C56.9161 34.4149 56.9657 35.224 56.2721 35.0424L55.6611 36.0992C55.6446 36.2148 55.6281 36.2809 55.6116 36.3469C55.5951 36.5451 55.5951 36.9414 55.5951 39.1211C55.5951 39.3854 55.6776 39.6331 55.8097 39.8477C55.9583 40.0789 56.173 40.2771 56.4372 40.3927C56.4372 40.3927 56.4537 40.3927 56.4537 40.4092C57.8904 41.0202 58.9472 41.4165 59.7564 41.7302Z"
        fill="white"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M56.8827 32.2681C56.9322 31.9379 56.7836 31.5085 56.668 31.2278C56.6515 31.1783 56.6185 31.1287 56.602 31.0792C56.0736 30.0223 54.8846 29.5765 53.7617 29.5104C50.8884 29.3618 50.6077 29.9067 49.716 29.0811C49.9967 29.4939 50.0132 30.1709 49.5839 30.9966C49.2866 31.5746 48.7087 31.8388 48.1802 32.0039C46.8592 29.0315 47.5197 27.1655 48.8243 26.505C48.3949 25.5638 48.3619 25.217 48.3619 25.217C48.3619 25.217 51.1361 25.6793 52.0774 25.4977C53.2828 25.25 55.1488 25.5472 55.8424 27.149C56.9983 27.5949 57.4442 28.338 57.5432 29.1141C57.7414 30.3526 57.0148 31.7232 56.8827 32.2681Z"
        fill="url(#paint0_linear_100_50475)"
      />
      <path
        d="M49.2706 36.4954C49.2211 36.4459 49.1881 36.3798 49.155 36.3303V36.1652C49.3036 36.4129 49.4853 36.6275 49.7 36.8257L51.7806 38.2954C52.2595 38.7082 52.9696 38.7082 53.465 38.3119L55.4135 36.5615C55.4796 36.5119 55.5456 36.4459 55.6117 36.3798"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M24.5335 57.6326H3.61121C2.2241 57.6326 1.1012 56.5097 1.1012 55.1226V25.8611C1.1012 24.474 2.2241 23.3511 3.61121 23.3511H24.5335C25.9206 23.3511 27.0435 24.474 27.0435 25.8611V55.1391C27.0435 56.5262 25.9206 57.6326 24.5335 57.6326Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M16.9867 49.3264H11.1411C10.4971 49.3264 9.96863 48.798 9.96863 48.154C9.96863 47.51 10.4971 46.9816 11.1411 46.9816H16.9867C17.6308 46.9816 18.1592 47.51 18.1592 48.154C18.1592 48.798 17.6308 49.3264 16.9867 49.3264Z"
        fill="#D6DCE8"
      />
      <path
        d="M19.6786 51.8694H8.46609C8.11931 51.8694 7.8551 51.5887 7.8551 51.2584C7.8551 50.9117 8.13583 50.6475 8.46609 50.6475H19.6786C20.0254 50.6475 20.2896 50.9282 20.2896 51.2584C20.2896 51.5887 20.0088 51.8694 19.6786 51.8694Z"
        fill="#D6DCE8"
      />
      <path
        d="M21.7263 35.5708C21.7263 37.8827 20.7024 39.9468 19.1007 41.3505C17.7466 42.5229 15.9962 43.233 14.0641 43.233C12.1321 43.233 10.3652 42.5229 9.02758 41.3505C7.4258 39.9468 6.40198 37.8827 6.40198 35.5708C6.40198 31.3434 9.83673 27.9087 14.0641 27.9087C18.2915 27.9087 21.7263 31.3434 21.7263 35.5708Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M19.1008 41.3509C17.7467 42.5234 15.9963 43.2335 14.0642 43.2335C12.1322 43.2335 10.3653 42.5234 9.02771 41.3509C9.58916 41.1363 10.3157 40.8555 11.29 40.4427C11.5212 40.3436 11.6863 40.1785 11.7854 39.9638C11.835 39.8482 11.868 39.7161 11.868 39.5675V37.7345C11.835 37.7015 11.8019 37.652 11.7854 37.619C11.6203 37.3878 11.5212 37.107 11.4882 36.8263L11.323 36.7438C10.8607 36.8593 10.8937 36.3474 10.7616 35.3897C10.7121 34.9934 10.7781 34.9108 10.9432 34.8447L11.0919 34.6466C10.1836 32.5824 10.646 31.2944 11.5377 30.8485C11.2405 30.2045 11.224 29.9568 11.224 29.9568C11.224 29.9568 13.1395 30.2706 13.8 30.155C14.6422 29.9898 15.9137 30.188 16.3926 31.2944C17.1852 31.6081 17.499 32.1201 17.565 32.6485C17.6311 33.1604 17.4825 33.6888 17.3504 34.1182C17.3339 34.1512 17.3339 34.1677 17.3173 34.2007C17.3173 34.2172 17.3008 34.2172 17.3008 34.2337C17.2843 34.2833 17.2678 34.3328 17.2513 34.3824C17.2348 34.3989 17.2348 34.4319 17.2183 34.4484C17.2018 34.498 17.1852 34.531 17.1687 34.5805V34.597C17.1522 34.6301 17.1357 34.6631 17.1357 34.6961C17.1192 34.7457 17.1027 34.7787 17.1027 34.8117C17.1192 34.8282 17.1192 34.8447 17.1192 34.8612C17.2513 34.9273 17.2843 35.0264 17.2348 35.3732C17.1192 36.2979 17.1522 36.8593 16.6733 36.7272L16.2605 37.4703C16.244 37.5529 16.2275 37.5859 16.2275 37.652C16.211 37.7841 16.211 38.0648 16.211 39.5675C16.211 39.7492 16.2605 39.9143 16.3596 40.0629C16.4587 40.228 16.6073 40.3602 16.7889 40.4262H16.8054C17.8293 40.8555 18.5558 41.1363 19.1008 41.3509Z"
        fill="white"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M17.1357 34.8113C17.1687 34.5802 17.0696 34.2994 16.987 34.0848C16.9705 34.0517 16.954 34.0187 16.9375 33.9857C16.5742 33.2591 15.7486 32.9453 14.9724 32.9123C12.9908 32.8132 12.7927 33.193 12.1817 32.6151C12.3799 32.9123 12.3964 33.3582 12.0991 33.9361C11.8845 34.3325 11.4881 34.5141 11.1414 34.6297C10.2331 32.5655 10.6955 31.2775 11.5872 30.8317C11.29 30.1876 11.2735 29.9399 11.2735 29.9399C11.2735 29.9399 13.189 30.2537 13.8495 30.1381C14.6917 29.973 15.9632 30.1711 16.4421 31.2775C17.2347 31.5913 17.5485 32.1032 17.6145 32.6316C17.7136 33.4903 17.2182 34.4315 17.1357 34.8113Z"
        fill="url(#paint1_linear_100_50475)"
      />
      <path
        d="M16.4088 40.0791V40.4424H11.8016V39.9635C11.8512 39.8479 11.8842 39.7158 11.8842 39.5672V37.7342C11.8512 37.7012 11.8181 37.6516 11.8016 37.6186V37.5195C11.9007 37.6847 12.0328 37.8498 12.1814 37.9654L13.6181 38.9727C13.9484 39.2534 14.4438 39.2699 14.7905 38.9892L16.1446 37.7837C16.1942 37.7507 16.2437 37.7012 16.2767 37.6516C16.2602 37.7837 16.2602 38.0645 16.2602 39.5672C16.2602 39.7488 16.3097 39.9305 16.4088 40.0791Z"
        fill="url(#paint2_linear_100_50475)"
      />
      <path
        d="M100.808 57.6326H79.8857C78.4986 57.6326 77.3757 56.5097 77.3757 55.1226V25.8611C77.3757 24.474 78.4986 23.3511 79.8857 23.3511H100.808C102.195 23.3511 103.318 24.474 103.318 25.8611V55.1391C103.318 56.5262 102.195 57.6326 100.808 57.6326Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M93.2612 49.3264H87.4155C86.7715 49.3264 86.2431 48.798 86.2431 48.154C86.2431 47.51 86.7715 46.9816 87.4155 46.9816H93.2612C93.9052 46.9816 94.4337 47.51 94.4337 48.154C94.4502 48.798 93.9218 49.3264 93.2612 49.3264Z"
        fill="#D6DCE8"
      />
      <path
        d="M95.9531 51.8694H84.7406C84.3939 51.8694 84.1296 51.5887 84.1296 51.2584C84.1296 50.9117 84.4104 50.6475 84.7406 50.6475H95.9531C96.2999 50.6475 96.5641 50.9282 96.5641 51.2584C96.5641 51.5887 96.2999 51.8694 95.9531 51.8694Z"
        fill="#D6DCE8"
      />
      <path
        d="M98.0171 35.5708C98.0171 37.8827 96.9933 39.9468 95.3915 41.3505C94.0375 42.5229 92.2871 43.233 90.355 43.233C88.423 43.233 86.656 42.5229 85.3185 41.3505C83.7167 39.9468 82.6929 37.8827 82.6929 35.5708C82.6929 31.3434 86.1276 27.9087 90.355 27.9087C94.5824 27.9087 98.0171 31.3434 98.0171 35.5708Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M95.3916 41.3509C94.0375 42.5234 92.2871 43.2335 90.355 43.2335C88.423 43.2335 86.6561 42.5234 85.3185 41.3509C85.8799 41.1363 86.6065 40.8555 87.5808 40.4427C87.812 40.3436 87.9771 40.1785 88.0762 39.9638C88.1257 39.8482 88.1588 39.7161 88.1588 39.5675V37.7345C88.1257 37.7015 88.0927 37.652 88.0762 37.619C87.9111 37.3878 87.812 37.107 87.779 36.8263L87.6138 36.7438C87.1515 36.8593 87.1845 36.3474 87.0524 35.3897C87.0028 34.9934 87.0689 34.9108 87.234 34.8447L87.3826 34.6466C86.4744 32.5824 86.9368 31.2944 87.8285 30.8485C87.5313 30.2045 87.5147 29.9568 87.5147 29.9568C87.5147 29.9568 89.4303 30.2706 90.0908 30.155C90.933 29.9898 92.2045 30.188 92.6834 31.2944C93.476 31.6081 93.7898 32.1201 93.8558 32.6485C93.9219 33.1604 93.7733 33.6888 93.6412 34.1182C93.6246 34.1512 93.6246 34.1677 93.6081 34.2007C93.6081 34.2172 93.5916 34.2172 93.5916 34.2337C93.5751 34.2833 93.5586 34.3328 93.5421 34.3824C93.5256 34.3989 93.5256 34.4319 93.509 34.4484C93.4925 34.498 93.476 34.531 93.4595 34.5805V34.597C93.443 34.6301 93.4265 34.6631 93.4265 34.6961C93.41 34.7457 93.3935 34.7787 93.3935 34.8117C93.41 34.8282 93.41 34.8447 93.41 34.8612C93.5421 34.9273 93.5751 35.0264 93.5256 35.3732C93.41 36.2979 93.443 36.8593 92.9641 36.7272L92.5513 37.4703C92.5348 37.5529 92.5182 37.5859 92.5182 37.652C92.5017 37.7841 92.5017 38.0648 92.5017 39.5675C92.5017 39.7492 92.5513 39.9143 92.6504 40.0629C92.7494 40.228 92.8981 40.3602 93.0797 40.4262H93.0962C94.1035 40.8555 94.8301 41.1363 95.3916 41.3509Z"
        fill="white"
        stroke="#D6DCE8"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M93.4101 34.8113C93.4431 34.5802 93.344 34.2994 93.2615 34.0848C93.2449 34.0517 93.2284 34.0187 93.2119 33.9857C92.8486 33.2591 92.023 32.9453 91.2468 32.9123C89.2653 32.8132 89.0671 33.193 88.4561 32.6151C88.6543 32.9123 88.6708 33.3582 88.3735 33.9361C88.1589 34.3325 87.7626 34.5141 87.4158 34.6297C86.5075 32.5655 86.9699 31.2775 87.8616 30.8317C87.5644 30.1876 87.5479 29.9399 87.5479 29.9399C87.5479 29.9399 89.4634 30.2537 90.1239 30.1381C90.9661 29.973 92.2376 30.1711 92.7165 31.2775C93.5092 31.5913 93.8229 32.1032 93.889 32.6316C93.988 33.4903 93.5092 34.4315 93.4101 34.8113Z"
        fill="url(#paint3_linear_100_50475)"
      />
      <path
        d="M92.6832 40.0791V40.4424H88.076V39.9635C88.1255 39.8479 88.1586 39.7158 88.1586 39.5672V37.7342C88.1255 37.7012 88.0925 37.6516 88.076 37.6186V37.5195C88.1751 37.6847 88.3072 37.8498 88.4558 37.9654L89.8924 38.9727C90.2227 39.2534 90.7181 39.2699 91.0649 38.9892L92.419 37.7837C92.4685 37.7507 92.518 37.7012 92.5511 37.6516C92.5346 37.7837 92.5346 38.0645 92.5346 39.5672C92.5346 39.7488 92.5841 39.9305 92.6832 40.0791Z"
        fill="url(#paint4_linear_100_50475)"
      />
      <path
        d="M96.8944 89.1233L76.0051 68.2505L80.794 63.4617L101.667 84.3509L96.8944 89.1233Z"
        fill="#D6DCE8"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M107.298 99.6092L91.2797 83.5914C89.9422 82.2538 89.9422 80.0741 91.2797 78.7365C92.6173 77.3989 94.7971 77.3989 96.1346 78.7365L112.152 94.7543C113.49 96.0919 113.49 98.2717 112.152 99.6092C110.815 100.947 108.635 100.947 107.298 99.6092Z"
        fill="#D6DCE8"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M106.158 100.633L85.5498 80.0245C85.071 79.5456 85.071 78.7695 85.5498 78.2741L90.8176 73.0064C91.2964 72.5275 92.0726 72.5275 92.568 73.0064L113.176 93.6149C113.655 94.0938 113.655 94.8699 113.176 95.3653L107.909 100.633C107.413 101.112 106.637 101.112 106.158 100.633Z"
        fill="#D6DCE8"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M52.3582 0.992188C30.4947 0.992188 12.776 18.7109 12.776 40.5744C12.776 62.4214 30.4947 80.1566 52.3417 80.1566C74.2052 80.1566 91.9239 62.4379 91.9239 40.5744C91.9239 18.7109 74.2052 0.992188 52.3582 0.992188ZM52.3582 72.8247C34.8046 72.8247 20.5868 58.3757 20.5868 40.5579C20.5868 22.7401 34.8046 8.30755 52.3582 8.30755C69.9118 8.30755 84.1297 22.7566 84.1297 40.5744C84.1297 58.3922 69.8953 72.8247 52.3582 72.8247Z"
        fill="#D6DCE8"
        stroke="#AAB2C5"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100_50475"
          x1="47.4546"
          y1="28.7433"
          x2="57.5791"
          y2="28.7433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100_50475"
          x1="10.6449"
          y1="32.3762"
          x2="17.6289"
          y2="32.3762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_100_50475"
          x1="14.1066"
          y1="40.4602"
          x2="14.1066"
          y2="38.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#E2E5EC" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_100_50475"
          x1="86.9193"
          y1="32.3762"
          x2="93.9037"
          y2="32.3762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0BACC" />
          <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_100_50475"
          x1="90.381"
          y1="40.4602"
          x2="90.381"
          y2="38.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#E2E5EC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
